import { ClariahLink } from "components/ClariahLink";
import { useEffect, useRef } from "react";
import cx from "classnames";
import styles from "./CategoriesBar.module.css";

export const CategoriesBar = ({ items }) => {
  const activeRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (activeRef.current && containerRef.current) {
      containerRef.current.scrollLeft =
        containerRef.current.scrollLeft +
        activeRef.current.getBoundingClientRect().left -
        20;
    }
  }, [activeRef.current, containerRef.current]);

  return (
    <div ref={containerRef} className={styles.container}>
      {items.map(({ isActive, label, href, type }, index) => (
        <ClariahLink
          className={cx(styles.link, { [styles.isActive]: isActive })}
          href={href}
          key={index}
          type={type}
        >
          <span ref={isActive ? activeRef : null}>{label}</span>
        </ClariahLink>
      ))}
      <div className={styles.mobileSpacer} />
    </div>
  );
};
